import React from "react";
import { connect } from "unistore/react";
import { store } from "./store";

class List extends React.Component {
  addActiveClassName(itemId) {
    return this.props.activeItem === itemId ? "active" : "inactive";
  }

  render() {
    return (
      <ul className="list">
        {this.props.items.map(item => {
          return (
            <li
              key={item.name}
              className={`listItem ${this.addActiveClassName(item.id)} ${
                item.color
              }`}
              onMouseOver={_ => {
                store.setState({ hoverItem: item.id });
              }}
              onMouseOut={_ => {
                store.setState({ hoverItem: 0 });
              }}
            >
              {item.name}
            </li>
          );
        })}
      </ul>
    );
  }
}

const connectedList = connect("items, activeItem")(List);

export { connectedList as List };
